import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

export interface RejectTaskDialogResult {
  adminComment: string;
}

@Component({
  selector: 'reject-task-dialog',
  templateUrl: './reject-task-dialog.component.html',
  standalone: false
})
export class RejectTaskDialogComponent {
  adminComment = '';

  constructor(public dialogRef: MatDialogRef<RejectTaskDialogComponent, RejectTaskDialogResult>) {}

  confirm() {
    this.dialogRef.close({adminComment: this.adminComment});
  }
}
